/**
 * Display helpers for recurring schedules — money + cadence formatting.
 * Foreign invoices show their billed currency amount; INR falls back to the
 * shared rupee formatter.
 */
import { paiseToInr } from "../../../lib/format.ts";

export interface SourceAmountLike {
  currencyCode: string;
  foreignAmountMinor: string | null;
  totalPaise: string;
}

export function formatSourceAmount(src: SourceAmountLike): string {
  if (src.currencyCode !== "INR" && src.foreignAmountMinor) {
    const major = Number(src.foreignAmountMinor) / 100;
    try {
      return new Intl.NumberFormat("en-US", { style: "currency", currency: src.currencyCode }).format(
        major,
      );
    } catch {
      return `${src.currencyCode} ${major.toFixed(2)}`;
    }
  }
  return paiseToInr(src.totalPaise);
}

const ORDINAL = (n: number): string => {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return `${n}${s[(v - 20) % 10] ?? s[v] ?? s[0]}`;
};

export function cadenceLabel(row: {
  cadence: string;
  monthEnd: boolean;
  dayOfMonth: number | null;
}): string {
  const cadence = row.cadence.charAt(0).toUpperCase() + row.cadence.slice(1);
  const anchor = row.monthEnd ? "Last day of month" : `On the ${ORDINAL(row.dayOfMonth ?? 1)}`;
  return `${cadence} · ${anchor}`;
}
